module.exports = __webpack_public_path__ + "img/facile.e754f1ae.svg";